import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23b4c828&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=23b4c828&prod&lang=scss&scoped=true"
import style1 from "@/components/pages/bonus/styles/index.scss?vue&type=style&index=1&id=23b4c828&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4c828",
  null
  
)

export default component.exports